<template>
  <div class="flex flex-col items-end ss xxx">
    Warloc
    <div class="text-sm mt-2 text-gray-500 font-bold">
      Unity In Motion
    </div>
  </div>
</template>